import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { isSystemAdmin } from '@/constants/capabilities';
import { getHomePath } from '@/constants/routes';
import { useAuthStore } from '@/stores/auth.store';

interface BusinessUserGuardProps {
  children: ReactNode;
}

/** 业务端（写日报/团队日报）仅非系统管理员可访问 */
export function BusinessUserGuard({ children }: BusinessUserGuardProps) {
  const user = useAuthStore((state) => state.user);

  if (!user) {
    return null;
  }

  if (isSystemAdmin(user)) {
    return <Navigate to={getHomePath(user)} replace />;
  }

  return <>{children}</>;
}
